import React, { useEffect, useState } from 'react';

import useOutsideClick from '@stencil/use-outside-click';
import copyToClipboard from '@stencil/flights-utils/src/copy-to-clipboard';

import * as S from './offer-overlay.styles';

const OfferOverlay = ({ offerOverlayData }) => {
  if (!offerOverlayData || !offerOverlayData.api_url) {
    return null;
  }
  const offerOverlayRef = React.createRef();

  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    if (document) {
      document.addEventListener('mouseout', handleMouseDown);
      const closeOfferOverlayEle = document.getElementById('closeOfferOverlay');
      const dfrtofferEle = document.getElementById('dfrtoffer');
      const dfowofferEle = document.getElementById('dfowoffer');
      if (closeOfferOverlayEle) {
        closeOfferOverlayEle.addEventListener('click', closeOverlay);
      }
      if (dfrtofferEle) {
        dfrtofferEle.addEventListener('click', () => {
          const code = document.getElementById('offerCode1')
            ? document.getElementById('offerCode1').innerText
            : '';
          handleCopyCode(code);
          dfrtofferEle.classList.add('selected');
          dfrtofferEle.innerText = 'Code Copied';
          setTimeout(() => {
            dfrtofferEle.classList.remove('selected');
            dfrtofferEle.innerText = 'Copy Code';
          }, 1000 * 5);
        });
      }
      if (dfowofferEle) {
        dfowofferEle.addEventListener('click', () => {
          const code = document.getElementById('offerCode2')
            ? document.getElementById('offerCode2').innerText
            : '';
          handleCopyCode(code);
          dfowofferEle.classList.add('selected');
          dfowofferEle.innerText = 'Code Copied';
          setTimeout(() => {
            dfowofferEle.classList.remove('selected');
            dfowofferEle.innerText = 'Copy Code';
          }, 1000 * 5);
        });
      }
    }
  }, []);

  const handleMouseDown = event => {
    if (!event.relatedTarget) {
      setShowOverlay(true);
      document.removeEventListener('mouseout', handleMouseDown);
    }
  };

  const closeOverlay = () => {
    setShowOverlay(false);
  };

  useOutsideClick(offerOverlayRef, () => {
    closeOverlay();
  });

  const handleCopyCode = text => {
    copyToClipboard(text);
  };

  return (
    <>
      <S.OfferButton onClick={() => setShowOverlay(true)}>
        <img src="https://gos3.ibcdn.com/img-1564997799.png" alt="Offer Image" loading="lazy" />
      </S.OfferButton>
      {showOverlay ? <S.OfferWrpBg /> : null}
      <S.OfferWrp className={showOverlay === true ? '' : 'topPos'} ref={offerOverlayRef}>
        <div dangerouslySetInnerHTML={{ __html: offerOverlayData.api_url }}></div>
      </S.OfferWrp>
    </>
  );
};

export default OfferOverlay;
